import { featuredTimeline, stories } from '@/mocks/stories';
import StatusBadge from './StatusBadge';

const typeStyle: Record<string, string> = {
  爆料: 'bg-primary-500 text-background-50',
  发酵: 'bg-accent-500 text-foreground-950',
  回应: 'bg-secondary-500 text-background-50',
  反转: 'bg-primary-700 text-background-50',
  收尾: 'bg-foreground-800 text-background-50',
};

export default function StoryTimeline() {
  const feature = stories[0];

  return (
    <section id="timeline" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600">STORY TIMELINE</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">瓜情时间线</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            以单个事件为例，从爆料起源到尘埃落定，每个节点都标出类型。反转和当事人发声会高亮显示，方便对照前后的差异。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="h-52 w-full overflow-hidden bg-background-200">
                <img
                  src={feature.image}
                  alt={`${feature.title}事件配图`}
                  title={`${feature.title} - 完整时间线`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded-md bg-foreground-950/80 px-2.5 py-1 text-xs font-medium text-background-50">
                    {feature.category}
                  </span>
                  <StatusBadge status={feature.status} />
                </div>
                <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950">
                  {feature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{feature.summary}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-fire-line text-primary-500" />
                    热度 {feature.heat}
                  </span>
                  <span className="whitespace-nowrap">共 {featuredTimeline.length} 个节点</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <ol className="relative flex flex-col gap-6 border-l border-background-300 pl-6 md:pl-8">
              {featuredTimeline.map((node) => (
                <li key={node.time} className="relative">
                  <span
                    className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 md:-left-[39px] ${
                      node.type === '反转' ? 'bg-primary-700' : 'bg-secondary-500'
                    }`}
                  />
                  <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
                    <div className="flex flex-wrap items-center gap-3">
                      <span
                        className={`whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${
                          typeStyle[node.type] ?? 'bg-background-300 text-foreground-800'
                        }`}
                      >
                        {node.type}
                      </span>
                      <span className="whitespace-nowrap text-xs font-medium text-foreground-500">{node.time}</span>
                    </div>
                    <h4 className="mt-2 font-heading text-base font-bold text-foreground-950">{node.title}</h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}